
<div
	class="big-n-filter-wrapper"
	v-bind="$props"
	:disabled="disabled"
	@click="handleClick($event)"
>
	<div class="big-n-filter-title">
		{{ title }}
	</div>
	<div class="big-n" :style="'font-size:' + numberSize + 'px'">
		<slot />
	</div>
	<div class="big-n-filter-footer">
		<span />
	</div>
</div>
